<p-multiSelect
  [options]="options"
  [optionLabel]="optionLabel"
  (onChange)="selectionChange($event)"
  [filter]="filter"
  defaultLabel="Выбрать"
  [showHeader]="showHeader"
  [selectedItemsLabel]="'Выбрано {0}'"
  [(ngModel)]="selectedItemsArray"
  [showToggleAll]="true"
  [resetFilterOnHide]="resetFilterOnHide"
  [inputId]="inputId"
  class="prime-multi-select"
  [styleClass]="styleClass"
  [showClear]="showClear"
  (onClear)="onClear()"
  [emptyFilterMessage]="emptyFilterMessage"
>
  <ng-template let-selectedOptions pTemplate="selectedItems">
    <ng-container *ngIf="selectedOptions && selectedOptions.length <= maxSelectedLabels">
      <div
        *ngFor="let selected of selectedOptions; let i = index"
        [id]="inputId + 'Item' + i"
        class="ui-multiselected-item-token ui-corner-all"
      >
        <span>{{ selected[optionLabel] }}</span>
      </div>
    </ng-container>
    <ng-container *ngIf="selectedOptions && selectedOptions.length >= maxSelectedLabels">
      <div [id]="inputId + 'Item'" class="ui-multiselected-item-token ui-corner-all">
        Выбрано {{ selectedOptions.length }}
      </div>
    </ng-container>
    <span
      *ngIf="!selectedOptions || selectedOptions.length === 0"
      class="ui-multiselected-empty-token ui-corner-all"
      >{{ defaultLabel }}</span
    >
  </ng-template>
</p-multiSelect>
